import { CoreOperation, CoreOperationResult, } from "../../core/index.js";
import * as PSM from "../data-psm-vocabulary.js";
export class DataPsmCreateClassReference extends CoreOperation {
    static TYPE = PSM.CREATE_CLASS_REFERENCE;
    /**
     * IRI of the newly created object.
     */
    dataPsmNewIri = null;
    /**
     * IRI of a specification.
     */
    dataPsmSpecification = null;
    /**
     * IRI of the PSM class.
     */
    dataPsmClass = null;
    constructor() {
        super();
        this.types.push(DataPsmCreateClassReference.TYPE);
    }
    static is(resource) {
        return resource?.types.includes(DataPsmCreateClassReference.TYPE);
    }
}
export class DataPsmCreateClassReferenceResult extends CoreOperationResult {
    static TYPE = PSM.CREATE_CLASS_REFERENCE_RESULT;
    createdDataPsmClassReference;
    constructor(dataPsmClass) {
        super();
        this.types.push(DataPsmCreateClassReferenceResult.TYPE);
        this.createdDataPsmClassReference = dataPsmClass;
    }
    static is(resource) {
        return resource?.types.includes(DataPsmCreateClassReferenceResult.TYPE);
    }
}
//# sourceMappingURL=data-psm-create-class-reference.js.map